import './ResetZoomButton.css';

type ResetZoomButtonProps = {
  onClick: () => void;
};

export const ResetZoomButton: React.FC<ResetZoomButtonProps> = ({
  onClick,
}) => {
  return (
    <button type='button' onClick={onClick} className='reset-btn'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
      >
        <path
          d='M10 4C12.3704 4 14.4178 5.37494 15.3926 7.37012L16.0225 5.35156C16.1046 5.08804 16.3849 4.94054 16.6484 5.02246C16.912 5.10458 17.0595 5.3849 16.9775 5.64844L15.8867 9.14844C15.8055 9.40895 15.5304 9.55629 15.2686 9.47949L11.8594 8.47949C11.5944 8.40177 11.4428 8.12435 11.5205 7.85938C11.5982 7.5944 11.8757 7.4428 12.1406 7.52051L14.6914 8.26855C13.987 6.36064 12.1524 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15C11.2092 15 12.317 14.5715 13.1816 13.8574C13.2674 13.7866 13.3508 13.713 13.4316 13.6367C13.6324 13.4472 13.9491 13.4564 14.1387 13.6572C14.3279 13.858 14.3187 14.1738 14.1182 14.3633C14.0213 14.4547 13.9212 14.543 13.8184 14.6279C12.7811 15.4845 11.4501 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4Z'
          fill='#5D5D5D'
        />
      </svg>
      Reset zoom
    </button>
  );
};
